export enum ModemType {
  EHS8 = 'EHS8',
  PLS62 = 'PLS62',
  PLS63 = 'PLS63',
  EXS82 = 'EXS82',
  UNKNOWN = 'Unknown'
}
